export const GENERIC_ERROR_MESSAGE = 'Sorry, something went wrong';
